import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioDesarrollo.css";

interface ServiceItem {
  title: string;
  desc: string;
}

interface TarjetaDeServicioDesarrolloProps {
  service: ServiceItem;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicioDesarrollo({ service, delay = 0, animationClass = "" }: TarjetaDeServicioDesarrolloProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`service-card animate-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` } as React.CSSProperties}
    >
      <h3 className="service-desarrollo-title">{service.title}</h3>
      <p className="service-desarrollo-text">{service.desc}</p>
    </div>
  );
}